"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradesAPI = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const getUrl = (endPath) => {
    const instance = (0, trade_utils_lib_1.getTradeDependencyInstance)();
    const host = instance.getRunTimeHost().botTradeHost;
    return `${host}${endPath}`;
};
var TradesAPI;
(function (TradesAPI) {
    const EMPTY_HISTORY = [];
    const EMPTY_KLINE_HISTORY = [];
    /**
     * 查询行情历史数据
     * @param request Trades.HistoryRequest
     * @returns TradeHistory - 数据是时间递减的（时间戳越大的数组下标越小）
     */
    TradesAPI.getHistory = (request) => {
        const url = getUrl("/kline/smart_trades_history");
        return trade_utils_lib_1.Network.get({ url, data: request }).pipe((0, operators_1.catchError)(() => (0, rxjs_1.of)(EMPTY_HISTORY)), // 如果出现错误，返回空数组
        (0, operators_1.map)((data) => {
            // 数据字段处理
            return (data || EMPTY_HISTORY)
                .map((item) => ({
                timestamp: item.timestamp,
                price: Number(item.price),
            }))
                .sort((a, b) => a.timestamp - b.timestamp);
        }));
    };
    /**
     * 查询行情 K 线历史数据
     * @param request Trades.HistoryKlineRequest
     * @returns TradeHistory - 数据是时间递减的（时间戳越大的数组下标越小）
     */
    TradesAPI.getKlineHistory = (request) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().klineHost + "/query_unite_candle_data";
        return trade_utils_lib_1.Network.get({ url, data: request }).pipe((0, operators_1.catchError)(() => (0, rxjs_1.of)({ history_price: EMPTY_KLINE_HISTORY })), // 如果出现错误，返回空数组
        (0, operators_1.map)((data) => {
            var _a;
            // 数据字段处理
            return (_a = ((data === null || data === void 0 ? void 0 : data.history_price) || EMPTY_KLINE_HISTORY)) === null || _a === void 0 ? void 0 : _a.map((item) => ({
                timestamp: item.date * 1000,
                price: Number(item.close),
            }));
        }));
    };
})(TradesAPI = exports.TradesAPI || (exports.TradesAPI = {}));
